/**
 * AmbientOrbsOverlay — CSS-only default background from
 * why-merryfix_implementation/src/index.css, ported verbatim so every
 * proposal opens with the same cinematic feel as the marketing landing.
 *
 * Three large blurred radial-gradient orbs (pink / violet / gold) drift
 * gently across a near-black page background, with a subtle SVG-noise
 * grain overlay for film texture. Each orb runs an independent keyframe
 * so the motion never feels synchronised.
 *
 * Rendered once at the root of the proposal viewer (admin + frontend),
 * behind every slide and per-slide ambient layer. Mounts only when
 * `code === 'ambient-orbs'`.
 */
import './ambient-orbs.css';

export function AmbientOrbsOverlay() {
  return (
    <div className="preview-ambient-page">
      <div className="preview-ambient-orb preview-ambient-orb--pink" />
      <div className="preview-ambient-orb preview-ambient-orb--violet" />
      <div className="preview-ambient-orb preview-ambient-orb--gold" />
      <div className="preview-ambient-grain" />
    </div>
  );
}
